import React from 'react';
import { CircularProgress, Typography, Backdrop, Paper } from '@mui/material';
import useStore from 'src/store/cns';

const Loading = () => {
  const loadingText = useStore(state => state.loadingText);
  return (
    <Backdrop
      data-cy="fetching-data"
      open={loadingText.length > 0}
      sx={{
        color: '#fff',
        zIndex: theme => theme.zIndex.drawer + 1,
      }}
    >
      <Paper
        elevation={3}
        sx={{
          padding: 4,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          borderRadius: 2,
        }}
      >
        <CircularProgress color="inherit" />
        {loadingText && (
          <Typography variant="h6" sx={{ marginTop: 2, textAlign: 'center' }}>
            {loadingText}
          </Typography>
        )}
        <Typography variant="body2" sx={{ marginTop: 1, textAlign: 'center' }}>
          This will only take a few seconds. Please do not close the window.
        </Typography>
      </Paper>
    </Backdrop>
  );
};

export default Loading;
